import React from 'react'
import classNames from 'classnames'
import { slugs } from '@/constants'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

interface TicketsFooterSweepstakesRulesProps {
  slug: string
  isDarkMode: boolean
}

const validSweepstakesSlugs = new Set([slugs.ruleBreakers, slugs.kingOfKings, slugs.theLastRodeo])

export const TicketsFooterSweepstakesRules: React.FC<TicketsFooterSweepstakesRulesProps> = ({ slug, isDarkMode }) => {
  const { t } = useTranslate('common')

  if (!validSweepstakesSlugs.has(slug)) return null

  return (
    <div className="space-y-2 px-4 md:px-0">
      <h3>{t('giveawayRules', 'Giveaway Rules')}</h3>
      <p className={classNames('text-[14px] font-light', isDarkMode ? 'text-gray-300' : 'text-gray-700')}>
        {(slug === slugs.braveTheDark || slug === slugs.ruleBreakers) && (
          <Translate t={t} i18nKey="btdSweepstakesGeneralRulesFooter">
            * * * LIMIT OF FIVE THOUSAND (5,000) ENTRIES PER PERSON/EMAIL ADDRESS. * * * NO PURCHASE OR PAYMENT OF ANY
            KIND IS NECESSARY TO ENTER OR WIN. PURCHASE OR PAYMENT DOES NOT IMPROVE YOUR CHANCE OF WINNING. The 200K
            Dream Vacation Giveaway is open only to legal residents of the 50 U.S. States & DC, age of majority +. Void
            elsewhere and where prohibited. Promotion ends 3/9/2025. Subject to complete Official Rules at{' '}
            <a href="https://bit.ly/200KDreamGiveaway" target="_blank" className="underline">
              https://bit.ly/200KDreamGiveaway
            </a>
          </Translate>
        )}
        {slug === slugs.kingOfKings && (
          <Translate t={t} i18nKey="tkokSweepstakesGeneralRulesFooter">
            * * * LIMIT OF 3,000 ENTRIES PER PERSON/EMAIL ADDRESS. * * * NO PURCHASE OR PAYMENT OF ANY KIND IS NECESSARY
            TO ENTER OR WIN. PURCHASE OR PAYMENT DOES NOT IMPROVE YOUR CHANCE OF WINNING. The King of Kings Giveaway is
            open only to legal residents of the 50 US States &amp; D.C., age of majority or older. Void elsewhere and
            where prohibited. Ends 4/27/2025. Odds of winning a prize depend on the number of eligible entries received.
            Subject to complete Official Rules at{' '}
            <a href="https://bit.ly/AngelFilmsKingofKings" target="_blank" className="underline">
              https://bit.ly/AngelFilmsKingofKings
            </a>
            .
          </Translate>
        )}
        {slug === slugs.theLastRodeo && (
          <Translate t={t} i18nKey="lastrodeoSweepstakesGeneralRulesFooter">
            * * * LIMIT OF 3,000 ENTRIES PER PERSON/EMAIL ADDRESS. * * * NO PURCHASE OR PAYMENT OF ANY KIND IS NECESSARY
            TO ENTER OR WIN. PURCHASE OR PAYMENT DOES NOT IMPROVE YOUR CHANCE OF WINNING. The Last Rodeo Giveaway is
            open only to legal residents of the 48 contiguous US States & D.C. (excluding HI and AK), age of majority or
            older. Void elsewhere and where prohibited. Ends 6/7/2025. Subject to complete Official Rules at{' '}
            <a href="https://bit.ly/TheLastRodeo" target="_blank" className="underline">
              https://bit.ly/TheLastRodeo
            </a>
            .
          </Translate>
        )}
      </p>
    </div>
  )
}
